import template from './gallery.html';
import controller from './gallery.controller';
import './gallery.scss';

let galleryComponent = {
  bindings: {
    item: "=",
    language: "<",
    reinit: "&"
  },
  template,
  controller,
  controllerAs: "vm"
};

export default galleryComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/gallery/gallery.component.js